export const Mydata = {
  data() {
    return {
      systemIds: [
        { id: '1', title: 'Android' },
        { id: '2', title: 'ios' },
        { id: '3', title: '小程序' },
      ],
      timeType: [
        { id: '1', title: '日' },
        { id: '2', title: '周' },
        { id: '3', title: '月' },
        { id: '4', title: '季' },
        { id: '5', title: '年' },
      ],
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      dimensionalData: [
        {
          title: '日期',
          value: 1000
        },
        {
          title: '事业群',
          value: 1001
        },
        {
          title: '部门',
          value: 1002
        },
        {
          title: '项目',
          value: 1003,
        },
        {
          title: '应用',
          value: 1004
        },
        {
          title: '系统',
          value: 1005
        },
      ],
      // 表格
      column: [],
      // 实际消耗
      real_column: [
        /* {
          fixed: false,
          label: "日期",
          prop: "date",
        },
        {
          label: "星期",
          prop: 'week',
        }, */
        {
          label: "",
          width: 120,
          children: [{
            label: "总实际消耗",
            prop: "real_price_total",
            sortable: 'custom',
          }
          ],
        },
        // {
        //   label: "总返点金额",
        //   children: [
        //     {
        //       label: "达人返款",
        //       prop: "auther_refund",
        //       sortable: 'custom',
        //       width: 160
        //     },
        //     {
        //       label: "代理返点",
        //       prop: "agent_rebate",
        //       sortable: 'custom',
        //       width: 160
        //     },
        //   ],
        // },
        {
          label: "星图实际消耗",
          children: [{
            label: "星图一口价",
            prop: "real_xt_price",
            sortable: 'custom',
            width: 180
          },
          {
            label: "星图招募投稿",
            prop: "xt_recruit_contribute",
            sortable: 'custom',
            width: 160
          },
          {
            label: "星图招募一口价",
            prop: "xt_recruit_price",
            sortable: 'custom',
            width: 160
          },
          {
            label: "星图Dou+",
            prop: "xt_dou",
            sortable: 'custom',
            width: 160
          },
          ],
        },
        {
          label: "聚星实际消耗",
          children: [{
            label: "聚星一口价",
            prop: "real_jx_price",
            sortable: 'custom',
            width: 200
          },
          {
            label: "聚星助推",
            prop: "jx_boost",
            sortable: 'custom',
            width: 180
          },
          {
            label: "聚星招募投稿",
            prop: "jx_recruit_contribute",
            sortable: 'custom',
            width: 180
          },
          ],
        },
        {
          label: "其他实际消耗",
          children: [{
            label: "小红书",
            prop: "red_book",
            sortable: 'custom',
            width: 200
          },
          {
            label: "私单",
            prop: "private_order",
            sortable: 'custom',
            width: 180
          },
          {
            label: "其他",
            prop: "other",
            sortable: 'custom',
            width: 180
          },
          ],
        },
      ],
      // 账面消耗
      paper_column: [
        /* {
          label: "",
          width: 240,
          fixed: false,
          children: [{
            label: "日期",
            prop: "date",
          },
          {
            label: "星期",
            prop: 'week',
          },
          ],
        }, */
        {
          label: "",
          width: 120,
          fixed: false,
          children: [{
            label: "总账面消耗",
            prop: "paper_price_total",
            sortable: 'custom',
          }
          ],
        },
        {
          label: "总返点金额",
          children: [
            {
              label: "达人返款",
              prop: "auther_refund",
              sortable: 'custom',
              width: 160
            },
            {
              label: "代理返点",
              prop: "agent_rebate",
              sortable: 'custom',
              width: 160
            },
          ],
        },
        {
          label: "星图账面消耗",
          children: [{
            label: "星图一口价",
            prop: "paper_xt_price",
            sortable: 'custom',
            width: 180
          },
          {
            label: "星图招募投稿",
            prop: "xt_recruit_contribute",
            sortable: 'custom',
            width: 160
          },
          {
            label: "星图招募一口价",
            prop: "xt_recruit_price",
            sortable: 'custom',
            width: 160
          },
          {
            label: "星图Dou+",
            prop: "xt_dou",
            sortable: 'custom',
            width: 160
          },
          ],
        },
        {
          label: "聚星账面消耗",
          children: [{
            label: "聚星一口价",
            prop: "paper_jx_price",
            sortable: 'custom',
            width: 200
          },
          {
            label: "聚星助推",
            prop: "jx_boost",
            sortable: 'custom',
            width: 180
          },
          {
            label: "聚星招募投稿",
            prop: "jx_recruit_contribute",
            sortable: 'custom',
            width: 180
          },
          ],
        },
        {
          label: "其他账面消耗",
          children: [{
            label: "小红书",
            prop: "red_book",
            sortable: 'custom',
            width: 200
          },
          {
            label: "私单",
            prop: "private_order",
            sortable: 'custom',
            width: 180
          },
          {
            label: "其他",
            prop: "other",
            sortable: 'custom',
            width: 180
          },
          ],
        },
      ],
    }
  }
}